import { eventHasRun } from '../../utils/eventTracker';

export const DDC_LINK_NAVCLICK = 'ddc.link.navClick';

function navigationClick(
	{
		DDC: {
			client: { isMobile }
		}
	},
	{ currentTarget: element, timeStamp }
) {
	let eventObject;
	const $element = $(element);

	if (
		!eventHasRun(DDC_LINK_NAVCLICK, {
			timeStamp
		})
	) {
		let isParentLink;
		let isChildLink;
		let isHeadingLink;
		const navigationPosition =
			$element.parents('.ddc-footer').length > 0 ? 'bottomNav' : 'topNav';
		let menuLinkText;

		if (isMobile) {
			isParentLink =
				$element.hasClass('accordion-faux') &&
				$element.not('.heading-tier2').length > 0;
			isChildLink = $element.hasClass('tier3');
			isHeadingLink = $element.hasClass('heading-tier2');
		} else {
			isParentLink =
				$element.parent().parent('.navbar-nav').length > 0 &&
				$element.parent().hasClass('nav-no-children');
			isChildLink = $element.hasClass('child');
			isHeadingLink = $element.parent('h4').length > 0;
		}

		if (navigationPosition === 'topNav' && isChildLink) {
			menuLinkText =
				$element
					.closest('.dropdown')
					.find('.nav-with-children')
					.first()
					.text() ||
				$element.parents('.panel').find('.panel-title').text().trim();
		}

		if (isParentLink || isChildLink || isHeadingLink) {
			eventObject = {
				eventType: DDC_LINK_NAVCLICK,
				eventData: {
					element,
					isChildLink,
					linkText: $element.text().trim(),
					megaMenu: $element.parents('.non-mega-menu').length === 0,
					menuLinkText,
					position: navigationPosition,
					url: $element.attr('href')
				}
			};
		}
	}
	return eventObject;
}

export default navigationClick;
